import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import InViewMonitor from 'react-inview-monitor'

import Video from './Video'

// cache to prevent creating new object every render call
const childPropsInView = { isPlaying: true }

class VideoAutoplayInView extends Component {
  constructor () {
    super()
    this.useInviewMonitor = this.useInviewMonitor.bind(this)
  }
  useInviewMonitor () {
    return this.props.scrollAutoplayEnabled
  }
  render () {
    return (
      <InViewMonitor
        useInviewMonitor={this.useInviewMonitor}
        childPropsInView={childPropsInView}
        toggleChildPropsOnInView
      >
        <Video {...this.props} />
      </InViewMonitor>
    )
  }
}

VideoAutoplayInView.propTypes = {
  src: PropTypes.string.isRequired,
  scrollAutoplayEnabled: PropTypes.bool.isRequired
}

function mapStateToProps ({ browser }) {
  return {
    scrollAutoplayEnabled: browser.greaterThan.md
  }
}

export default connect(mapStateToProps)(VideoAutoplayInView)



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/VideoAutoplayInView.js